import { render, staticRenderFns } from "./ReserveOrderPreview.vue?vue&type=template&id=cf24d6fa&scoped=true"
import script from "./ReserveOrderPreview.vue?vue&type=script&lang=js"
export * from "./ReserveOrderPreview.vue?vue&type=script&lang=js"
import style0 from "./ReserveOrderPreview.vue?vue&type=style&index=0&id=cf24d6fa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf24d6fa",
  null
  
)

export default component.exports